import { studentFinderActionTypes } from '.';

export const getStudentList = (search: string) => ({
  type: studentFinderActionTypes.GET_STUDENT_LIST,
  payload: { search },
} as const);
export const getStudentListSuccess = (data: GetDataSuccessPayload) => ({
  type: studentFinderActionTypes.GET_STUDENT_LIST_SUCCESS,
  payload: { data },
} as const);
export const getStudentListFail = () => ({
  type: studentFinderActionTypes.GET_STUDENT_LIST_FAIL,
} as const);
export const getStudentListCancel = () => ({
  type: studentFinderActionTypes.GET_STUDENT_LIST_CANCEL,
} as const);

export const chooseSingleStudent = (studentId: number) => ({
  type: studentFinderActionTypes.CHOOSE_SINGLE_STUDENT,
  payload: { studentId },
} as const);

export const getSubjectForStudentList = (studentId: number, semestrAkademicki: string, rokAkademicki: string) => ({
  type: studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST,
  payload: { studentId, semestrAkademicki, rokAkademicki },
} as const);
export const getSubjectForStudentListSuccess = (data: GetDataSuccessPayload, studentId: number) => ({
  type: studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST_SUCCESS,
  payload: { data, studentId },
} as const);
export const getSubjectForStudentListFail = () => ({
  type: studentFinderActionTypes.GET_SUBJECT_FOR_STUDENT_LIST_FAIL,
} as const);

export const resetReducer = () => ({
  type: studentFinderActionTypes.RESET_REDUCER,
} as const);

export const changeSelectOpen = (opened: boolean) => ({
  type: studentFinderActionTypes.CHANGE_SELECT_OPEN,
  payload: { opened },
} as const);